import { useTranslation } from 'react-i18next';
import { SelectItemSearchFormComponent } from '@/formbuilder/SelectItemSearchFormComponent';
import { TextFieldFormComponent } from '@/formbuilder/TextFieldFormComponent.atom';
import { Checkbox } from '@seeqdev/qomponents';
import type { ReactNode } from 'react';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import type { SelectedSearchItem } from '@/search/search.types';

export interface ToggleInputSelectItemSearchFormComponentProps extends ValidatingFormComponent<
  string | number | SelectedSearchItem[] | null
> {
  component: 'ToggleInputSelectItemSearchFormComponent';
  showItemSelection?: boolean;
  setShowItemSelection: (columnId: string, showItemSelection: boolean) => void;
  label?: string | ReactNode;
  name: string;
  size: 'sm' | 'lg';
  value: string | number | SelectedSearchItem[] | null;
  required: boolean;
  testId?: string;
  onChange: (value: string | number | SelectedSearchItem[] | null) => void;
  isMultiple?: boolean;
  notSelectedMessage: string;
  title?: string;
  overrideWorkbookId?: string;
  searchTypes: string[];
  iconPartialTooltipKey: string;
  customCalcInstructions: string;
  unit?: string;
  showToggle?: boolean;
  scopeIds?: string[];
}

export const ToggleInputSelectItemSearchFormComponent = (props: ToggleInputSelectItemSearchFormComponentProps) => {
  const {
    showItemSelection = false,
    setShowItemSelection,
    showToggle = true,
    value,
    name,
    testId,
    size,
    required,
    onChange,
    searchTypes,
    notSelectedMessage,
    iconPartialTooltipKey,
    overrideWorkbookId,
    isMultiple,
    customCalcInstructions,
    scopeIds,
    unit,
  } = props;

  const { t } = useTranslation();

  return (
    <div className="flexRowContainer width-70percent">
      <div className="flexRowContainer">
        {showToggle ? (
          <div className="flexColumnContainer">
            <Checkbox
              type="radio"
              value="valueInput"
              checked={!showItemSelection}
              onChange={() => setShowItemSelection(name, false)}
              id="valueInputCheckbox"
              label={t('IMPACT_REPORT.ENTER_AMOUNT')}
            />
            <Checkbox
              extraClassNames="ml10"
              type="radio"
              checked={showItemSelection}
              value="customSignalInput"
              onChange={() => setShowItemSelection(name, true)}
              id="valueInputCheckbox"
              label={t('IMPACT_REPORT.USE_CALCULATION')}
            />
          </div>
        ) : (
          <div>{props.label}</div>
        )}
      </div>
      {showItemSelection ? (
        <div className="flexRowContainer">
          <div className="flexColumnContainer flexAlignCenter">
            <SelectItemSearchFormComponent
              component="SelectItemSearchFormComponent"
              title="IMPACT_REPORT.SELECT_CALCULATION"
              name={name}
              value={value as SelectedSearchItem[]}
              scopeIds={scopeIds}
              isMultiple={isMultiple}
              searchTypes={searchTypes}
              iconPartialTooltipKey={iconPartialTooltipKey}
              overrideWorkbookId={overrideWorkbookId}
              onChange={onChange}
              notSelectedMessage={notSelectedMessage}
            />
          </div>
          <span className="font-size-smaller">{customCalcInstructions}</span>
        </div>
      ) : (
        <div className="flexColumnContainer flexAlignCenter">
          <TextFieldFormComponent
            type="number"
            min={0}
            component="TextFieldFormComponent"
            label=""
            wrapperClassNames="width-maximum"
            name={name}
            testId={testId}
            value={value as number}
            onChange={onChange}
            required={required}
            size={size}
          />
          {unit && unit !== '' && <div className="ml5">{unit}</div>}
        </div>
      )}
    </div>
  );
};
